import Page from 'components/Page/Page'
import React from 'react'
import Table from 'components/Display/Table/Table'
import {
    useCreateFaultLogMutation,
    useDeleteFaultLogMutation,
    useGetFaultLogQuery,
    useGetFaultLogsQuery,
} from 'store/Store'
import tableActions from 'constants/tableActions'

const FaultLog = () => {
    return (
        <Page>
            <Table
                itemName="fault_log"
                paginationType="external"
                allowDelete
                allowExpanded
                useEditMutation={useCreateFaultLogMutation}
                useGetQuery={useGetFaultLogsQuery}
                useGetByIdQuery={useGetFaultLogQuery}
                useCreateMutation={useCreateFaultLogMutation}
                useDeleteMutation={useDeleteFaultLogMutation}
                tableActions={tableActions.faultLogTableActions}
            />
        </Page>
    )
}

export default FaultLog
